export default __webpack_public_path__ + "static/oven-overlay-bfedb7c5834369742b529d592564591f.png";